module.exports = "<div class=\"container\">\r\n  <div class=\"row\">\r\n    <!-- error page -->\r\n    <div class=\"col-md-6 project-title\">\r\n      Whoops! Project does not exist!\r\n      <div class=\"project-description\">You have navigated to a non-existent project page. Please use a valid project id.</div>\r\n    </div>\r\n  </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/error-page/error-page.component.html
// module id = ./src/app/error-page/error-page.component.html
// module chunks = main